// id -> route name
// name -> title of the section
export const MDMMenu = [
  {
    id: 'VehicleDetail',
    name: 'Vehicle details',
    permission: 'view_vehicledetail',
    config: 'override_type_with_vehicle',
  },
  {
    id: 'DriverDetail',
    name: 'Driver details',
    permission: 'view_driverdetail',
  },
  {
    id: 'Users',
    name: 'Users',
    permission: 'view_users',
  },
  {
    id: 'ndc_master',
    name: 'NDC Master',
    permission: 'view_ndc_compliance',
  },
];

// view_ndc_compliance
export const actionButtons = [
  {
    id: 'reject_list',
    name: 'Rejected List',
    show: false,
    class: 'header_sbtn',
    disabled: false,
    emitMethod: 'rejectDownload',
  },
  {
    id: 'upload',
    name: 'Upload',
    show: true,
    class: 'header_sbtn',
    disabled: false,
    dropdownList: [{
      id: 'bulk_upload',
      type: 'upload',
      name: 'Bulk Upload',
      uploadEmitMethod: 'bulkUpload',
    },
    {
      id: 'vehicleDetailBulkUpload',
      type: 'upload',
      name: 'Vehicle Bulk Upload',
      uploadEmitMethod: 'bulkUpload',
      sampleFileEmitMethod: 'getBulkUploadExcel',
    }],
  },
  {
    id: 'export',
    name: 'Export',
    show: true,
    class: 'header_sbtn',
    disabled: false,
    emitMethod: 'exportData',
  },
  {
    id: 'add',
    name: 'Add',
    show: true,
    class: 'header_pbtn',
    disabled: false,
    emitMethod: 'add',
  },
];

// components which dont have search option
export const hideSearch = [];

// common search parameters
export const defaultSearchParameters = [
  {
    id: 1,
    name: 'Name',
    query: 'name',
  },
  {
    id: 2,
    name: 'Reference Id',
    query: 'ref_id',
  },
];
